// Hilfsfunktion: Sucht ein Label, dessen innerer Text den angegebenen Text enthält.
function findLabelByTextContains(text) {
  const labels = document.querySelectorAll('label');
  for (let i = 0; i < labels.length; i++) {
    if (labels[i].innerText.trim().includes(text)) {
      return labels[i];
    }
  }
  return null;
}

document.addEventListener("click", function(e) {
  // Prüfe, ob ein Label mit "Holzrahmen Anti-Reflex" angeklickt wurde.
  const frameLabel = e.target.closest('label');
  if (frameLabel && frameLabel.innerText.includes("Holzrahmen Anti-Reflex")) {
    console.log("Holzrahmen Anti-Reflex Option angeklickt.");
    
    // Nach 300ms: Simuliere Klick auf die erste Schriftzug-Option
    setTimeout(function() {
      const letterInputs = document.querySelectorAll('input[name="globo-option-1"]');
      if (letterInputs.length > 0) {
        const firstLetterInput = letterInputs[0];
        const letterLabel = document.querySelector(`label[for="${firstLetterInput.id}"]`);
        if (letterLabel) {
          const clickEvent = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
          letterLabel.dispatchEvent(clickEvent);
          console.log("Erste Schriftzug-Option ausgewählt:", firstLetterInput.value);
        } else {
          console.warn("Kein zugehöriges Label für die erste Schriftzug-Option gefunden.");
        }
      } else {
        console.warn("Keine Schriftzug-Optionen (input[name='globo-option-1']) gefunden.");
      }
      
      // Nach weiteren 300ms: Simuliere Klick auf die Größe "50x70 cm"
      setTimeout(function() {
        const sizeLabel = findLabelByTextContains("50x70 cm");
        if (sizeLabel) {
          const clickEvent = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
          sizeLabel.dispatchEvent(clickEvent);
          console.log("Größen-Option '50x70 cm' ausgewählt.");
        } else {
          console.warn("Kein Größen-Label mit '50x70 cm' gefunden.");
        }
      }, 300);
      
    }, 300);
  }
});
